export default __webpack_public_path__ + "static/media/anterior.00e8ee2a.png";